export const contactsData = {
    email: 'shmoha@iu.edu',
    phone: '+1-812-606-7637',
    address: 'Bloomington, Indiana, United States',

    sheetAPI: 'https://sheetdb.io/api/v1/nrcr0k4c4i1ke'
}